import {useParams} from 'react-router-dom'

import {Loader} from 'common/components'
import {
  BorrowerProjectScheduleStats,
  UserProjectScheduleList,
  useGetProjectTransactions,
} from '..'

export default function BorrowerProjectSchedule() {
  const params = useParams()
  const {data: transactions} = useGetProjectTransactions(params.uuid)

  if (!transactions) return <Loader />

  return (
    <>
      <BorrowerProjectScheduleStats />
      <UserProjectScheduleList />
    </>
  )
}
